import { FormLayout } from '@/components/Shared/FormLayout'
import {
    MidmarkButton,
    MidmarkFormikTextField,
} from '@midmark-enterprise/shared-components'
import { Formik, FormikProps } from 'formik'
import { useCallback, useContext, useState } from 'react'
import {
    UserRegistrationDataContext,
    UserSignupWizardPages,
} from '../user-signup-modal.component'

type CompanyInformationStepProps = {
    handleBackButton: (page: UserSignupWizardPages) => void
    handleForwardButton: () => void
}

export default function CompanyInformationStep(
    props: CompanyInformationStepProps,
): JSX.Element {
    const userRegistrationData = useContext(UserRegistrationDataContext)

    const [formFilled, setFormFilled] = useState(false)

    const validate = useCallback((values: { companyName: string }) => {
        setFormFilled(true)
    }, [])

    const handleSubmit = useCallback(
        (
            values: { companyName: string },
            action: {
                setFieldError: (fieldName: string, errorMessage: string) => void
                setSubmitting: (isSubmitting: boolean) => void
            },
        ) => {
            props.handleForwardButton()
        },
        [],
    )

    const handleBackButton = (): void => {
        props.handleBackButton(UserSignupWizardPages.emailVerification)
    }

    const submitForm = useCallback((props: FormikProps<any>) => {
        if (!props.isSubmitting) {
            props.submitForm()
        }
    }, [])

    return (
        <Formik
            initialValues={{
                companyName: '',
            }}
            validateOnChange={false}
            validateOnBlur={true}
            validate={validate}
            onSubmit={handleSubmit}
        >
            {(props) => (
                <>
                    <FormLayout
                        title="Company Information"
                        description="Enter information about your company. We'll make sure it's accurate and up to date."
                        buttons={
                            <>
                                <MidmarkButton
                                    onClick={handleBackButton}
                                    data-testid={DATA_TESTIDS.backButton}
                                    color="secondary"
                                >
                                    Back
                                </MidmarkButton>
                                <MidmarkButton
                                    isSubmitting={props.isSubmitting}
                                    data-testid={DATA_TESTIDS.continueButton}
                                    type="submit"
                                >
                                    Continue
                                </MidmarkButton>
                            </>
                        }
                    >
                        <MidmarkFormikTextField
                            label="Company Name"
                            placeholder="Enter name"
                            formikProps={props}
                            autoComplete="off"
                            name="companyName"
                            required={true}
                            data-testid={DATA_TESTIDS.companyNameTextField}
                        />
                    </FormLayout>
                    {formFilled && submitForm(props)}
                </>
            )}
        </Formik>
    )
}

export const DATA_TESTIDS = {
    continueButton: 'continue-button',
    backButton: 'back-button',
    companyNameTextField: 'company-name-text-field',
    formikForm: 'formik-form',
}
